import React from 'react';

import { ReactFCC } from '@types';

import { SLoyaltyBackground, SLoyaltyPoint } from '../styled';

import { ILoyaltyBanner } from './model';

export const LoyaltyBanner: ReactFCC<ILoyaltyBanner> = ({ children, withIcon = true, ...rest }) => (
  <SLoyaltyBackground data-testid={'loyalty-banner'} {...rest}>
    {withIcon && <SLoyaltyPoint data-testid="loyalty-point-picto" />}
    <div data-testid="loyalty-banner-content">{children}</div>
  </SLoyaltyBackground>
);
